<template>
  <div class="swiper-slide course-card-item">
    <div
      class="course-image"
      :style="{
        backgroundImage: courseInfo.image ? `url(${config.baseUrl + courseInfo.image})` : ''
      }"
    >
      <!-- <div class="image_badge">Promo</div> -->
    </div>
    <div class="course_text">
      <p>{{ courseInfo.name }}</p>
      <span>{{ courseInfo.description }}</span>
    </div>
    <div class="course_price">
      <!-- <div class="stars_block">
                <i class="mdi mdi-star active" ></i>
                <i class="mdi mdi-star active" ></i>
                <i class="mdi mdi-star active" ></i>
                <i class="mdi mdi-star active" ></i>
                <i class="mdi mdi-star " ></i>
            </div> -->
      <!-- <div class="price_block">
                1853 руб
            </div> -->
    </div>
    <button class="course-button" @click="$emit('click', courseInfo.id)">
      Подробнее <i class="icon-button-arrow"></i>
    </button>
  </div>
</template>

<script>
import { config } from '@/config'

export default {
  props: {
    courseInfo: {
      default: () => {},
      type: Object
    }
  },
  computed: {
    config() {
      return config
    }
  }
}
</script>
